<template>
    <div>
        <div class="flex justify-content-between">
            <div class="h3 ftw600">
                {{ $t('userMySetting.setting') }}
            </div>
			<div class="flex">
				<!-- <button type="button" class="btn btn-outline-gray" @click="toEditPassWord"> {{$t('login.editPassword')}}<a href="#" class="cl-black "></a></button> -->
				<button type="button" class="btn btn-outline-gray ms-3" @click="logOut">{{ $t('userMySetting.logOut') }}</button>
			</div>
        </div>

        <div class="bg-w p-3 border-gray br8 mt-4">
			<div class="flex space">
				<div class="ftr-1-25 ftw600">
				    {{ $t('userMySetting.basicInfo') }}
				</div>
				<div>
					{{ $t('userMySetting.userCode') }}: {{form.id}}
				</div>
			</div>
            
			<div class="ftr-1-2 mt-3 cl-red ">
			    {{ $t('userMySetting.fillInformation') }}
			</div>
            <!-- <div class="mt-2">
                {{ $t('userMySetting.photo') }}
            </div> -->
            <div class="mt-2">
                <upload-img v-model="form.avatar"></upload-img>
            </div>
            <div class="cl-red mt-2">
                {{ $t('userMySetting.uploadAvatarTip') }}
            </div>
            <div class="row mt-4">
                <div class="col-sm-6">
                    <div class="">
                        {{ $t('userMySetting.name') }}
						<span class="cl-red">*</span>
                    </div>
                    <a-input v-model:value="form.nickname" :placeholder="$t('userMySetting.inputNamePlaceholder')" class="ft16 mt-2"
                        style="height: 40px;" />

                    <div class="mt-3">
                        {{ $t('userMySetting.gender') }}
                    </div>
                    <select class="form-select ft16 mt-2" v-model="form.gender" aria-label="Default select example">
                        <option value="0">{{ $t('userMySetting.selectPlaceholder') }}</option>
                        <option value="1">{{ $t('userMySetting.male') }}</option>
                        <option value="2">{{ $t('userMySetting.female') }}</option>
                    </select>

                    <div class="mt-3">
                        {{ $t('userMySetting.timeZone') }}
						<span class="cl-red">*</span>
                    </div>
                    <select class="form-select ft16 mt-2" aria-label="Default select example"
                        v-model="form.time_zone_id">
                        <option :value="item.id" v-for="(item,index) in timeZoneList">{{item.name}}</option>
                    </select>

                    <div class="mt-3">
                        {{ $t('userMySetting.currency') }}
						
                    </div>
                    <select class="form-select ft16 mt-2" aria-label="Default select example"
                        v-model="form.currency_id">
                        <option :value="item.id" v-for="(item,index) in currencyList">{{item.currency}}</option>
                    </select>
					
					<div class="flex mt-3 alcenter">
						<div class="mr10">
						    {{ $t('userMySetting.iam') }}
							<span class="cl-red">*</span>
						</div>
						<a-checkbox-group v-model="identityList">
							<a-checkbox value="1">{{$t('userMySetting.studentsOrParents')}}</a-checkbox>
							<a-checkbox value="2">{{$t('userMySetting.teacher')}}</a-checkbox>
						</a-checkbox-group>
					</div>
                </div>
                <div class="col-sm">
                    <div class="">
                        {{ $t('userMySetting.birthday') }}
                    </div>
                    <div class="mt-2">
                        <a-date-picker v-model:value="form.birthday" valueFormat="YYYY-MM-DD"
                            style="width: 100%;height: 40px;" />
                    </div>

                    <div class="mt-3">
                        {{ $t('userMySetting.displayLanguage') }}
						<span class="cl-red">*</span>
                    </div>
                    <select class="form-select ft16 mt-2" aria-label="Default select example"
                        v-model="form.language_id">
                        <option :value="item.id" v-for="(item,index) in languageList">{{item.name}}</option>
                    </select>

                    <div class="mt-3">
                        {{ $t('userMySetting.country') }}
						<span class="cl-red">*</span>
                    </div>
                    <select class="form-select ft16 mt-2" aria-label="Default select example" v-model="form.nation_id">
                        <option :value="item.id" v-for="(item,index) in travelLocationList">{{item.name}}</option>
                    </select>
					<div class="mt-3">
					    {{ $t('userMySetting.contactPhone') }}
						<span class="cl-red">*</span>
					</div>
					<a-input v-model:value="form.mobile" :placeholder="$t('recharge.inputPrompt')" class="ft16 mt-2"
					    style="height: 40px;" />
                </div>
            </div>
            <button type="button" class="btn btn-theme mt-3 wid-fit" @click="updateInfo">{{ $t('userMySetting.save') }}</button>
        </div>

        <div class="bg-w p-3 border-gray br8 mt-4">
            <div class="ftr-1-25 ftw600">
                {{ $t('userMySetting.accountVerification') }}
            </div>
            <div class="mt-3">
                {{ $t('userMySetting.email') }}
            </div>
            <div class="flex alcenter mt-2">
                <a-input v-model:value="form.email" :placeholder="$t('userMySetting.inputEmailPlaceholder')" class="ft16" style="height: 40px;width: 300px;" />
                <button type="button" class="btn btn-outline-theme ml16" @click="sendEmail">{{ $t('userMySetting.sendVerificationEmail') }}</button>
            </div>
            <div class="mt-3">
                {{ $t('userMySetting.password') }}
            </div>
            <button type="button" class="btn btn-outline-theme mt-2" @click="toEditPassWord">{{ $t('userMySetting.editPassword') }}</button>

            <div class="mt-3">
                {{ $t('userMySetting.bindApp') }}
            </div>

            <div class="border-gray br4 mt-3 p-3" style="width: 422px;">
                <div class="flex alcenter justify-content-between">
                    <div class="flex alcenter">
                        <img src="../../../assets/image/commom/facebook.png" alt="" class="photo-40" />
                        <span class="ml15">{{ $t('userMySetting.facebook') }}</span>
                    </div>
                    <button type="button" class="btn btn-outline-theme">{{ $t('userMySetting.clickToBind') }}</button>
                </div>
				
				<div class="pos-re ">
					
					<div class="flex alcenter justify-content-between mt-3" >
					    <div class="flex alcenter">
					        <img src="../../../assets/image/commom/google.png" alt="" class="mySetting-icon" />
					        <span class="ml15">{{ $t('userMySetting.google') }}</span>
					    </div>
						<button type="button" class="btn btn-outline-theme" v-if="form.sub&&form.sub!=''"@click="thirdRemoveBinding">{{ $t('userMySetting.unbind') }}</button>
					    <button type="button" class="btn btn-outline-theme"style="width: 90px;"  v-else  @click="bindGoogle">{{ $t('userMySetting.clickToBind') }}</button>
						
					</div>
				</div>
                <div class="flex alcenter justify-content-between mt-3">
                    <div class="flex alcenter">
                        <img src="../../../assets/image/commom/wechat.png" alt="" class="mySetting-icon" />
                        <span class="ml15">{{ $t('userMySetting.wechat') }}</span>
                    </div>
                    <button type="button" class="btn btn-outline-theme" style="width: 90px;">{{ $t('userMySetting.unbind') }}</button>
                </div>
            </div>
            <button type="button" class="btn btn-theme mt-3">{{ $t('userMySetting.save') }}</button>
        </div>
		
		<div v-if="showGoogle">
			<google-bind @ok="showGoogle = false;getUserInfo()"></google-bind>
		</div>
    </div>
</template>

<script>
	import googleBind from './googleBind.vue'
    import uploadImg from '../../../components/upload/upload.vue'
    export default {
        components: {
            uploadImg,
			googleBind
        },
        data() {
            return {
                form: {},
                languageList: [], //语言
                currencyList: [], //货币
                timeZoneList: [], //时区
                travelLocationList: [], //国家
                countdown: 0,
				showGoogle:false,
				identityList:['1']
            }
        },
        mounted() {
            this.informationIntegration()
            this.getUserInfo()
        },
        methods: {
			bindGoogle(){
				this.showGoogle = true
			},
			thirdRemoveBinding(){
				this.$http.api('user/thirdRemoveBinding', {
					type:'google',
				}).then(res=>{
					this.$message.success(this.$t('common.operationSuccessful') )
					 this.getUserInfo()
				})
			},
            informationIntegration() {
                this.$http.api('information/informationIntegration', {
                    type: ["language", "currency", "timeZone", "travelLocation"]
                }).then(res => {
                    this.languageList = res.list.language.list
                    this.currencyList = res.list.currency.list
                    this.timeZoneList = res.list.timeZone.list
                    this.travelLocationList = res.list.travelLocation.list
                })
            },
            getUserInfo() {
                this.$http.api('user/index', {

                }).then(res => {
                    this.form = res.info
					if(this.form.teacher_id&&this.form.teacher_id!=null){
						this.identityList.push('2')
					}
                    this.updateUserInfo(res.info)
					localStorage.setItem('timeZone',res.info.time_zone.name)
                })
            },
            updateInfo() {
                this.$http.api('user/update', this.form).then(res => {
                    this.$message.success(this.$t('userMySetting.save') + '成功')
                    this.getUserInfo()
                })
            },
            logOut() {
                this.$confirm({
                    title: this.$t('userMySetting.confirmLogout'),
                    content: this.$t('userMySetting.logoutContent'),
                    okText: this.$t('common.confirm'),
                    okType: "danger",
                    cancelText: this.$t('common.cancel'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
                    onOk: () => {
                        localStorage.setItem('account-token', null)
						this.updateUserInfo(null)
						this.updateTeacherInfo(null)
                        this.$router.push('/login')
                    },
                    onCancel: () => {
                        console.log("Cancel");
                    },
                });
            },
            toEditPassWord() {
                this.$router.push('/register?type=edit&title=edit')
            },
            sendEmail() {
                if (this.countdown > 0) return; // 如果倒計時未結束，則不執行
                if (!this.form.email) {
                    this.$message.info(this.$t('userMySetting.inputEmailPlaceholder'))
                    return
                }
                this.$http.api('user/sendEmail', {
                    email: this.form.email,
                    event: 'change'
                }).then(res => {
                    this.countdown = 60; // 初始化倒計時
                    const timer = setInterval(() => {
                        if (this.countdown > 0) {
                            this.countdown--;
                        } else {
                            clearInterval(timer);
                        }
                    }, 1000);
                })

            },
        }
    }
</script>

<style scoped>
    .ant-input {
        height: 40px !important;
    }

    .mySetting-icon {
        width: 35px;
        height: 35px;
        border-radius: 50%;
    }
	/* ::v-deep.mySetting.nsm7Bb-HzV7m-LgbsSe{
		position: absolute !important;
	} */
	::v-deep.mySetting .nsm7Bb-HzV7m-LgbsSe{
		/* position: absolute !important;
		width: 100%;
		height: 58px;
		z-index: 99; */
		opacity: 0;
	}
</style>